// extracted by mini-css-extract-plugin
export default {"initialsAvatar":"InitialsAvatar_initialsAvatar__bqI6x"};